var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icons",
    viewBox: "0 0 74 74",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,72H10.3A3.308,3.308,0,0,1,7,68.7V27a1,1,0,0,1,1-1H66a1,1,0,0,1,1,1V68.7A3.308,3.308,0,0,1,63.7,72ZM9,28V68.7A1.306,1.306,0,0,0,10.3,70H63.7A1.306,1.306,0,0,0,65,68.7V28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7,28H5.3A3.308,3.308,0,0,1,2,24.7V18.308A3.308,3.308,0,0,1,5.3,15H68.7a3.308,3.308,0,0,1,3.3,3.3V24.7A3.308,3.308,0,0,1,68.7,28ZM5.3,17a1.306,1.306,0,0,0-1.3,1.3V24.7A1.306,1.306,0,0,0,5.3,26H68.7A1.306,1.306,0,0,0,70,24.7V18.308A1.306,1.306,0,0,0,68.7,17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37,17a.985.985,0,0,1-.387-.078,1,1,0,0,1-.535-1.309c2.275-5.43,4.633-10.656,6.451-12.124a6.792,6.792,0,0,1,9.536,1.05,7.078,7.078,0,0,1,1.447,5.136,6.965,6.965,0,0,1-2.5,4.712c-.99.8-3.143,1.649-6.573,2.578a1,1,0,0,1-.523-1.93C48,13.933,49.33,13.182,49.76,12.833a4.959,4.959,0,0,0,1.764-3.362A5.068,5.068,0,0,0,50.5,5.792a4.789,4.789,0,0,0-6.723-.741c-1.673,1.351-4.824,8.868-5.86,11.339A1,1,0,0,1,37,17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37,17a1,1,0,0,1-.922-.613C35.042,13.919,31.891,6.4,30.215,5.049a4.788,4.788,0,0,0-6.72.743,5.068,5.068,0,0,0-1.019,3.679,4.956,4.956,0,0,0,1.759,3.358c.435.353,1.766,1.1,5.847,2.209a1,1,0,0,1-.523,1.93c-3.431-.929-5.583-1.773-6.578-2.582a6.962,6.962,0,0,1-2.493-4.708,7.078,7.078,0,0,1,1.447-5.136A6.79,6.79,0,0,1,31.468,3.49c1.821,1.47,4.179,6.7,6.454,12.126a1,1,0,0,1-.535,1.309A.985.985,0,0,1,37,17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41,72H33a1,1,0,0,1-1-1V27.051a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1V71A1,1,0,0,1,41,72Zm-7-2h6V28.051H34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.9ed0a71b94166dc4c03f43da6e49ceb7.svg";
export { ForwardRef as ReactComponent };